<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<!-- Multi Select Menu -->
<draggable-container
	#dragContainer
	*ngIf="showMenu$ | async"
	[ngClass]="{ 'hide-menu': hideMenu$ | async }"
	[draggable]="showOptions"
	[resizable]="false"
	[width]="200"
	[deadZoneSize]="0"
	[containerType]="containerType"
>
	<div *ngIf="showOptions" automationId="multiSelectDraggableContainer">
		<div class="multi-select-menu-header">
			{{ AppStrings.MULTI_SELECT_MENU }}
		</div>
		<div class="multi-select-menu-header-desc">
			{{ AppStrings.MULTI_SELECT_MENU_DESC }}
		</div>

		<div class="multi-select-menu-divider"></div>
		<div class="multi-select-wrapper multi-edit-menu-zindex">
			<div class="read-only-text" *ngIf="isReadOnly$ | async">{{ AppStrings.MULTI_SELECT_LOCKED_PLAN }}</div>
			<div
				class="menu-item--light"
				(click)="editAll()"
				*ngIf="!(planAccessCheck.hasRestrictedAccess$ | async) || (isFloat$ | async)"
				[ngClass]="{ 'is-disabled': anyCompleted$ | async }"
				automationId="multiSelectEditAll"
			>
				<i class="menu-icon--blue material-icons" aria-hidden="true">edit</i>
				{{ AppStrings.MULTI_SELECT_MENU_EDIT_ALL }} ({{ numTickets }})
			</div>
			<div class="menu-item--light" (click)="editLocations()" automationId="multiSelectEditLocation">
				<i class="menu-icon--blue material-icons" aria-hidden="true">location_on</i>
				{{ AppStrings.MULTI_SELECT_MENU_EDIT_LOCATIONS }} ({{ numTickets }})
			</div>
			<div
				class="menu-item--light"
				(click)="copyToClipboard()"
				*ngIf="
					(enableClipboard$ | async) && !(planAccessCheck.hasRestrictedAccess$ | async) && !(isFloat$ | async)
				"
				[ngClass]="{ 'is-disabled': (selectedActiveAndPullTickets$ | async) || (isFloat$ | async) }"
				automationId="multiSelectCopyToClipboard"
			>
				<i class="menu-icon--blue material-icons" aria-hidden="true">content_copy</i>
				{{ AppStrings.MULTI_SELECT_MENU_COPY_TO_CLIPBOARD }} ({{ numTickets }})
			</div>
			<div
				class="menu-item--light"
				(click)="alignRows()"
				*ngIf="!(isReadOnly$ | async) && !(isFloat$ | async)"
				[ngClass]="{ 'is-disabled': isFloat$ | async }"
				automationId="multiSelectAlignRows"
			>
				<i class="menu-icon--blue material-icons" aria-hidden="true">table_rows</i>
				{{ AppStrings.MULTI_SELECT_MENU_ALIGN_ROWS }}
			</div>
			<div
				class="menu-item--light"
				(click)="duplicate()"
				*ngIf="!(isReadOnly$ | async) || (isFloat$ | async)"
				automationId="multiSelectDuplicate"
			>
				<i class="menu-icon--blue material-icons">file_copy</i>
				{{ AppStrings.MULTI_SELECT_MENU_DUPLICATE }} ({{ numTickets }})
			</div>
			<div
				class="menu-item--light"
				(click)="delete()"
				*ngIf="!(isReadOnly$ | async) || (isFloat$ | async)"
				automationId="multiSelectDelete"
			>
				<i class="menu-icon--blue material-icons">delete</i>
				{{ AppStrings.MULTI_SELECT_MENU_DELETE }} ({{ numTickets }})
			</div>
		</div>
		<div class="multi-select-menu-divider"></div>
	</div>

	<cycle-tickets
		[tickets]="ticket$ | async"
		[syncIsFloat]="syncIsFloat"
		automationId="multiSelectCycleTickets"
	></cycle-tickets>
</draggable-container>
